
// @ts-nocheck
import locale_es_45ES_46json_8ef17cc4 from "#nuxt-i18n/8ef17cc4";
import locale_pt_45PT_46json_0e905f5c from "#nuxt-i18n/0e905f5c";

export const localeCodes =  [
  "es",
  "pt"
]

export const localeLoaders = {
  es: [
    {
      key: "locale_es_45ES_46json_8ef17cc4",
      load: () => Promise.resolve(locale_es_45ES_46json_8ef17cc4),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_45PT_46json_0e905f5c",
      load: () => Promise.resolve(locale_pt_45PT_46json_0e905f5c),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "es",
      name: "ES",
      domain: "familycard.es",
      files: [
        {
          path: "/app/i18n/lang/es-ES.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pt",
      name: "PT",
      domain: "familycard.pt",
      files: [
        {
          path: "/app/i18n/lang/pt-PT.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "es",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: false,
  langDir: "lang",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: true,
  baseUrl: "",
  customRoutes: "config",
  pages: {
    promocion: {
      es: "/legal/condiciones-promocionales",
      pt: "/legal/condicoes-promocionais"
    },
    family_card: {
      es: "/legal/reglamento-family-card",
      pt: "/legal/regulamento-family-card"
    },
    register: {
      es: "/hazte-socio",
      pt: "/torna-te-membro"
    },
    regulations: {
      es: "/politica-de-privacidad",
      pt: "/politica-de-privacidade"
    },
    "catalog-index": {
      es: "/folleto-de-navidad",
      pt: "/folheto-de-natal"
    },
    "catalog-register": {
      es: "/folleto-de-navidad/hazte-socio",
      pt: "/folheto-de-natal/torna-te-membro"
    },
    "catalog-success": {
      es: "/folleto-de-navidad/gracias",
      pt: "/folheto-de-natal/obrigado"
    }
  },
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "es",
    name: "ES",
    domain: "familycard.es",
    files: [
      {
        path: "/app/i18n/lang/es-ES.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pt",
    name: "PT",
    domain: "familycard.pt",
    files: [
      {
        path: "/app/i18n/lang/pt-PT.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/